<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-payout-address coin="ETH"></table-payout-address>
    </v-container>
  </div>
</template>

<script>
import TablePayoutAddress from "@/components/table/TablePayoutAddress";

export default {
  name: "CardanoWalletList",
  components: {
    TablePayoutAddress
  }
};
</script>

<style scoped></style>
